import apiUrls from "src/api";
import type { SpeechLanguage } from "../types/audio";

export interface GradiumTokenResponse {
  token: string;
  expiresAt: string | null;
  language: string;
  sttWsUrl: string;
}

export async function fetchGradiumToken(language?: SpeechLanguage): Promise<GradiumTokenResponse> {
  const jwt = localStorage.getItem("wixar.auth.jwt");
  const url = new URL(apiUrls.voiceMode.gradiumToken);
  if (language) url.searchParams.set("language", language);
  const response = await fetch(url.toString(), {
    method: "GET",
    headers: jwt ? { Authorization: `Bearer ${jwt}` } : {},
  });
  if (!response.ok) {
    throw new Error(`Gradium token fetch failed: ${response.status}`);
  }
  return (await response.json()) as GradiumTokenResponse;
}
